import { orderBy } from "@progress/kendo-data-query";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { allDatasets } from "../../Common/Store/CommonSignals";
import { DatasetCreationWindow } from "../../Datasets/DatasetCreationWindow";
import { showDatasetCreationWindow } from "../../Template/NewTemplateSignals";

export function DatasetListHelper() {
  const datasets = allDatasets.value;
  return orderBy(
    datasets.filter((dataset) => dataset.datasetType === "List"),
    [{ field: "datasetName", dir: "asc" }]
  );
}

const CreateDatasetButton = () => {
  return (
    <Button
      style={{
        color: "#0078D4",
        fontWeight: "bold",
        width: "100%",
        border: "none",
      }}
      onClick={(e) => {
        e.stopPropagation();
        showDatasetCreationWindow.value = true;
      }}
    >
      Create Dataset
    </Button>
  );
};

export const DatasetProperty = {
  propertyName: "Dataset",
  propertyDisplay: "Dataset",
  propertyType: "string",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <>
        <DropDownList
          data={DatasetListHelper()}
          header={<CreateDatasetButton />}
          dataItemKey="id"
          textField="datasetName"
          onChange={(e) => {
            const { id, datasetName } = e.target.value;
            handlePropertyChange({ propName: this.propertyName, propValue: { id, datasetName } });
          }}
          value={currentPropertyValues?.[this.propertyName] || ""}
        />
        <DatasetCreationWindow handlePropertyChange={handlePropertyChange} />
      </>
    );
  },
};
